import { motion } from "framer-motion";
import { Search, Map, Rocket, GraduationCap } from "lucide-react";

const STEPS = [
	{ icon: Search, title: "360° School Audit", desc: "Deep catchment analysis, competitor mapping & brand health check." },
	{ icon: Map, title: "Growth Roadmap", desc: "Custom admission target blueprint with clear milestones." },
	{ icon: Rocket, title: "Multi-Channel Launch", desc: "Marketing & inquiry generation across every parent touchpoint." },
	{ icon: GraduationCap, title: "Admission Conversion", desc: "Counselling, follow-up systems & sustained enrollment ops." },
];

export function Process() {
	return (
		<section className="py-16 md:py-24 bg-slate-50 dark:bg-slate-950/40">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="max-w-2xl mb-12">
					<p className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-600 dark:text-emerald-400">How it works</p>
					<h2 className="mt-3 font-heading text-3xl sm:text-4xl font-bold text-slate-900 dark:text-white">
						A proven path from enquiry to enrollment
					</h2>
				</div>
				<div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
					{STEPS.map((s, i) => (
						<motion.div key={s.title}
							initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
							transition={{ delay: i * 0.08 }}
							className="relative rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-6"
						>
							<span className="absolute top-5 right-5 font-heading text-4xl font-extrabold text-slate-100 dark:text-slate-800">
								{i + 1}
							</span>
							<span className="grid place-items-center h-11 w-11 rounded-xl bg-emerald-500/10 text-emerald-600 dark:text-emerald-400">
								<s.icon className="h-5 w-5" />
							</span>
							<h3 className="mt-4 font-heading text-lg font-semibold text-slate-900 dark:text-white">{s.title}</h3>
							<p className="mt-2 text-sm text-slate-600 dark:text-slate-400">{s.desc}</p>
						</motion.div>
					))}
				</div>
			</div>
		</section>
	);
}
